// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n * 按钮\n */\n.am-button-primary {\n  border-radius: 0.047rem !important;\n}\n/**\n * 导航条\n */\n.am-navbar-light {\n  color: #333;\n}\n", ""]);
// Exports
module.exports = exports;
